
import { request } from './request'

import barrageApi from "./barrage"
import clockApi from "./clock"
import mapApi from "./map"

const userApi = {
  getSuggestion:params=>{
    let newParam = {
      ...params,
      openid:window.openid
    }
    return request({
      url: "/User/AddSuggestions",
      params:newParam,
    })
  },
  getUserVerify:()=>{
    return request({
      url: "/UserVerify/GetList",
      params: {
        openid: window.openid
      },
    })
  },
  getReportData:()=>{
    return request({
      url: "/User/GetReportData",
      params: {},
    })
  },
  getChannelType:()=>{
    return request({
      url:"/ChannelApi/GetMenu",
      params:{ }
    })
  },
  getAccount:(params)=>{
    return request ({
      url:'/User/AddCount',
      params:params
    })
  }

}

const featureApi = {
  getFeatureList:params=>{
    return request({
      url:"/FeatureApi/GetListByTypeId",
      params:params,
    })
  },
  playLog:params=>{
    return request({
      url:"/User/AddPlayLog",
      params:params,
    })
  }
}

const orderApi={
  add:params=>{
    return request({
      url: "/Reservation/Add",
      data:params,
      method:"POST"
    })
  },
  getList:params=>{
    return request({
      url: "/Reservation/GetList",
      params: {
        ...params,
        openid: window.openid
      },
    })
  }
}
const newsApi = {
  getList:id=>{
    return request({
      url: "/NewsApi/GetById",
      params: {
        id: id||1,
        _t:new Date().getTime()
      },
    })
  }
}

export default{
  barrageApi,
  clockApi,
  userApi,
  featureApi,
  mapApi,
  orderApi,
  newsApi
}
